import { Component, HostListener, ViewChild, ElementRef, inject, TemplateRef } from '@angular/core';
import { AdminService } from 'src/app/services/admin/admin.service';
// import { faUser, faUserPen, faLanguage, faLock, faRightFromBracket, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ChangeThemesComponent } from 'src/app/components/layout/change-themes/change-themes.component';
import { PwaInstallComponent } from 'src/app/components/layout/pwa-install/pwa-install.component';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { ChangeLanguageComponent } from '../change-language/change-language.component';
import { ChangeMyInfoComponent } from '../change-my-info/change-my-info.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ChangeThemesComponent,
    ChangePasswordComponent,
    ChangeLanguageComponent,
    ChangeMyInfoComponent,
    PwaInstallComponent,
    MatIconModule
  ],
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent {

  @ViewChild('dropdownMenu', { static: false }) dropdownMenu: ElementRef;

  isPasswordOpen = false;
  isLanguagesOpen = false;
  isInfoOpen = false;
  dropdownOpen = false;


  private modalService = inject(NgbModal);
  modalRef: NgbModalRef | null = null;

  constructor(public adminService: AdminService) {
    
  }
  ngOnInit(): void {
    // განაახლეთ მხიარული ცვლილებები
  }

  
  openModal(content: TemplateRef<any>, category: any | null = null): void {
    this.modalRef = this.modalService.open(content, {
      backdropClass: 'light-blue-backdrop',
      scrollable: true,
      size: 'sm',
    });
    const modalElement = document.querySelector('.modal-dialog');
    modalElement.classList.add('modal-sm', 'm-auto', 'mt-5'); 
  }

  open(section: 'password' | 'languages' | 'info'): void {
    // Reset all sections
    this.isPasswordOpen = false;
    this.isLanguagesOpen = false;
    this.isInfoOpen = false;
  
    // Update the state based on the section
    if (section === 'password') this.isPasswordOpen = true;
    if (section === 'languages') this.isLanguagesOpen = true;
    if (section === 'info') this.isInfoOpen = true;
  
    // Change modal size dynamically if it's already opened
    if (this.modalRef) {
      const modalElement = document.querySelector('.modal-dialog');
      if (modalElement) {
        if (section === 'password') {
          modalElement.classList.remove('modal-sm'); // Remove other sizes
          modalElement.classList.add('modal-md'); // Add small size
        } 
        if (section === 'info') {
          modalElement.classList.remove('modal-sm'); // Remove other sizes
          modalElement.classList.add('modal-md'); // Add small size
        } 
      }
    }
  }

  logout(event: Event): void {
    this.modalRef.close()
    this.adminService.logout();
  }

  closeAllSections(event?: Event): void {

    this.isPasswordOpen = false;
    this.isLanguagesOpen = false;
    this.isInfoOpen = false;
    if (this.modalRef) {
      const modalElement = document.querySelector('.modal-dialog');
      if (modalElement) {
          modalElement.classList.remove('modal-md'); // Remove small size
          modalElement.classList.add('modal-sm', 'm-auto', 'mt-5'); // Add default large size
        }
    }
  }



}